export const toStr = (
  v: number | string | null | undefined
): string => (v == null ? '' : String(v))

/** Format string[] for display (comma-separated) */
export const printCodesToStr = (v: string[] | null | undefined): string =>
  Array.isArray(v) ? v.join(', ') : v == null ? '' : String(v)

/** Parse comma-separated string to string[] for DB */
export const strToPrintCodes = (s: string): string[] | null => {
  const codes = s.split(',').map((x) => x.trim()).filter(Boolean)
  return codes.length ? codes : null
}

export const toJsonStr = (v: unknown): string =>
  v == null ? '' : JSON.stringify(v)

export const formatDate = (date: string | null): string =>
  date ? new Date(date).toLocaleDateString() : '–'

export const parseNum = (s: string): number | null =>
  s === '' ? null : Number.isNaN(Number(s)) ? null : Number(s)

export const parseJson = (s: string): unknown => {
  const trimmed = s.trim()
  if (!trimmed) return null
  try {
    return JSON.parse(trimmed)
  } catch {
    return null
  }
}

/**
 * Parse a JavaScript array literal from a string.
 * Supports both JSON and JS syntax (unquoted keys, trailing commas).
 */
export const parseJsArray = (text: string): unknown[] => {
  const trimmed = text.trim()
  if (!trimmed) return []

  try {
    const parsed = JSON.parse(trimmed)
    if (!Array.isArray(parsed)) {
      throw new Error('Value must be an array')
    }
    return parsed
  } catch {
    try {
      const fn = new Function(`return (${trimmed})`)
      const parsed = fn()
      if (!Array.isArray(parsed)) {
        throw new Error('Value must be an array')
      }
      return parsed
    } catch (e) {
      throw new Error(
        e instanceof Error ? e.message : 'Invalid JavaScript array syntax'
      )
    }
  }
}
